// extracted by mini-css-extract-plugin
export default {"modalText":"ConfirmText_modalText__9oGEc","modalTextOpen":"ConfirmText_modalTextOpen__s83i6","buttons":"ConfirmText_buttons__k82Vs"};